export enum CONSENT_CATEGORY {
  STRICTLY_NECESSARY = 'STRICTLY_NECESSARY',
  FUNCTIONALITY = 'FUNCTIONALITY',
  ANALYTICS = 'ANALYTICS',
  MARKETING = 'MARKETING',
}
